import { useMenuItems } from "./useMenuItems";
import { getSearchParam } from "../../../util/useLocation";
import { Contractor, EfiModules, Insued, User } from "../../../interface/user.interface";
import { do_login, do_mod } from "../../../sec/actions";
import { IPolicyMenuItem } from "./PolicyMenu";
import { usePolicyMenuStore } from "../../../store/policy-menu.store";
import { useDispatch } from "react-redux";
import { useUser } from "../../../custom-hooks/useUser";
import { useEffect } from "react";

export const useAutoSelectProfile = () => {
    const { tabIndex: currentIndexPolicyMenu, setPolicyMenuState } = usePolicyMenuStore();
    const dispatch = useDispatch();
    const user = useUser();
    const policies = useMenuItems();

    useEffect(() => {
        autoSelectProfile();
    }, []);

    const getTabIndexBySearchParams = () => {
        const uuid = getSearchParam("uuid");
        const module = getSearchParam("module");
        const pathname = window.location.pathname;
        const matchProfileIndex = policies.findIndex(
            policyItem => policyItem.uuid === uuid && policyItem?.module?.name === module
        );
        if (uuid || module) window.history.replaceState(null, "", pathname);
        return matchProfileIndex;
    };

    const autoSelectProfile = () => {
        if (!policies.length) return;

        let tabIndexSelected = policies.findIndex(policyMenu => policyMenu.anyRecentPolicy);
        tabIndexSelected = tabIndexSelected === -1 ? 0 : tabIndexSelected;
        const tabIndexBySearchParams = getTabIndexBySearchParams();
        if (tabIndexBySearchParams >= 0) {
            tabIndexSelected = tabIndexBySearchParams;
        } else if (currentIndexPolicyMenu < policies.length && currentIndexPolicyMenu !== -1) {
            tabIndexSelected = currentIndexPolicyMenu;
        }
        onChangeMenuTab(tabIndexSelected);
        setOnSelectItem(policies[tabIndexSelected]);
    };

    const updateUserAndModule = (user: User, moduleName: EfiModules) => {
        sessionStorage.setItem("efi_mod", moduleName);
        dispatch(do_mod(moduleName));
        dispatch(
            do_login({
                ...user,
                moduleName,
            })
        );
    };

    const setContractorUser = (contractor: Contractor) => {
        if (!contractor) return;
        const userCloned: User = JSON.parse(JSON.stringify(user));
        userCloned.cdCliente = contractor.cdCliente ?? null;
        userCloned.nmAsegurado = contractor.nmAsegurado;
        userCloned.apAsegurado = contractor.apAsegurado;
        updateUserAndModule(userCloned, EfiModules.Gen);
    };

    const setInsuedUser = (insued: Insued) => {
        if (!user.isAdmin && !insued?.cedula) {
            console.error("Sin cédula");
            return;
        }
        const userCloned = JSON.parse(JSON.stringify(user));
        userCloned.cedula = insued.cedula ?? null;
        userCloned.nmAsegurado = insued.nmCliente;
        userCloned.apAsegurado = insued.apCliente;
        updateUserAndModule(userCloned, EfiModules.Vam);
    };

    const setOnSelectItem = (policy: IPolicyMenuItem | null) => {
        const module = policy?.module;
        if (!module) return;
        const moduleName = module.name;
        if (moduleName === EfiModules.Vam) setInsuedUser(module.member);
        if (moduleName === EfiModules.Gen) setContractorUser(module.member);
    };

    const onChangeMenuTab = (tabIndex = -1) => {
        if (tabIndex >= 0) setPolicyMenuState({ tabIndex });
    };

    return { autoSelectProfile, onChangeMenuTab, setOnSelectItem };
};
